import { useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import gsap from 'gsap';

import styles from './index.module.scss';
import { PRODUCTS } from './constants';
import Slide from './Slide';

const cx = classNames.bind(styles);
gsap.defaults({ ease: 'none', duration: 10 });

const S04 = () => {
  const containerRef = useRef();
  const sliderRef = useRef();

  useEffect(() => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          scrub: true,
          pin: true,
          start: 'top top',
          end: '+=600%',
          pinSpacing: true,
        },
      })
      .to(sliderRef.current, { left: '-100%', backgroundColor: '#FF6CA5' })
      .to(sliderRef.current, { left: '-200%', backgroundColor: '#05A55B' })
      .to(sliderRef.current, { left: '-300%', backgroundColor: '#2851E8' });
  }, []);

  return (
    <section ref={containerRef} className={cx('container')}>
      <div ref={sliderRef} className={cx('slider')}>
        {PRODUCTS.map((product, index) => (
          <article key={index} className={cx('slide')}>
            <Slide data={product} />
          </article>
        ))}
      </div>
    </section>
  );
};

export default S04;
